import {Typography} from "@material-ui/core";

export const cardTitle = <Typography variant="subtitle2">
    Ricerca
</Typography>

export const esitoCambioFormatoRadioButtons = [
    {text: "Numero di Telefono", value: "numeroDiTelefono"},
    {text: "Numero Seriale", value: "numeroSeriale"},
    {text: "ID lotto", value: "idLotto"},
];


export const esitoCambioFormatoFilter = {
    esitoCambioFormato: {
        label: "Esito cambio formato",
        value: "",
    },
    numeroDiTelefono: {
        label: "Numero di Telefono",
        value: "",
    },
    numeroSeriale: {
        label: 'Numero Seriale',
        value: ""
    },
    dataInvioRichiesta: {
        name: 'Data invio richiesta',
        from: null,
        to: null
    },
    idLotto: {
        label: 'ID lotto',
        value: ""
    },
    email:{
        label: 'Email',
        value: ""
    }
}

export const sortingCriteria = [
    {text: "ID lotto", value: "requestId"},
    {text: "N. Telefono", value: "msisdnOld"},
    {text: "N. Seriale", value: "iccidNew"},
    {text: "Data invio richiesta", value: "creationDate"},
    {text: "Esito cambio formato", value: "action"},
    {text: "Causale KO", value: "errorCode"},
];